import { render, staticRenderFns } from "./daily-sale.vue?vue&type=template&id=33ab3c55&"
import script from "./daily-sale.vue?vue&type=script&lang=js&"
export * from "./daily-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports